<template>
  <div class="not-found-page">
    <!-- <div class="logo-wrapper">
      <router-link :to="{ name: 'home'}">
        <logo class="logo"></logo>
      </router-link>
    </div> -->

    <div>
      <div class="digits">404</div>
      <div class="text">Сторінку не знайдено. Перейти на <router-link :to="{ name: 'home'}">головну</router-link>.</div>
    </div>

    <div class="fake-footer"></div>
    <!-- <page-footer></page-footer> -->
  </div>
</template>

<script>

import Logo from '@/components/Logo';
import PageFooter from '@/components/PageFooter';

export default {
  name: 'NotFoundPage',
  components: {
    Logo,
    PageFooter,
  },
};

</script>

<style scoped>

.not-found-page {
  /*height: 100%;*/
  /*background: #171917;*/
  text-align: center;
  color: rgba(255,255,255, .3);
  font-size: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

a {
  color: rgba(255,255,255, .3);
}

.digits {
  font-size: 220px;
  font-weight: bold;
}

</style>

<style>

.global-page-container.not-found {
  background: #171917;

}

.global-page-container.not-found .icon {
  color: #eee;
}

</style>



// WEBPACK FOOTER //
// src/containers/NotFoundPage.vue